import type { AvatarProps } from "@mui/material";
import { Avatar, Typography, useTheme } from "@mui/material";
import type { FunctionComponent } from "react";

import type { SerializedUser } from "../context/user-context";

interface UserAvatarProps {
  user: SerializedUser;
  size?: number;
  sx?: AvatarProps["sx"];
}

const getInitial = (name?: string) => {
  if (name?.[0]) {
    return name[0].toUpperCase();
  }
  return "U";
};

export const UserAvatar: FunctionComponent<UserAvatarProps> = ({
  user,
  size = 32,
  sx = [],
}) => {
  const { palette } = useTheme();
  const { preferredName, userAvatarUrl } = user || {};

  return (
    <Avatar
      src={userAvatarUrl ?? undefined}
      sx={[
        {
          width: size,
          height: size,
          backgroundColor: palette.gray[20],
          border: "1px solid",
          borderColor: palette.gray[30],
          color: palette.gray[70],
          fontSize: size / 2,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Typography
        sx={{ color: "inherit", fontSize: "inherit", fontWeight: "inherit" }}
      >
        {getInitial(preferredName)}
      </Typography>
    </Avatar>
  );
};
